import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-navy text-center text-silver" aria-label="Limited time offer" data-id="element-219" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-electric shadow-glow" aria-hidden="true" data-id="element-220" data-mp="36ar3f73u9e4h" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-221" data-mp="31iz86j9qmk80">
        <p className="inline-flex items-center gap-2 font-display text-base font-bold uppercase tracking-[.16em] text-electric" data-id="element-222" data-mp="31hegr2ipzhed">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-223" data-mp="3b9k604hl7kpv" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-224" data-mp="3p9boahf4zn9o" />
        <p className="mt-7 font-bold text-silver" data-id="element-225" data-mp="3p8a6lu3m82iz">After that the price increases and never drops again.</p>
      </div>
      <div className="h-1 w-full bg-electric shadow-glow" aria-hidden="true" data-id="element-226" data-mp="3l53yegwy019v" />
    </section>;
}